/** Helpers for assigning calendar dates to imported weekly workout programs. */

/** Returns `count` consecutive local dates starting tomorrow (relative to `from`). */
export function getUpcomingProgramDates(count: number, from: Date = new Date()): Date[] {
  const base = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const dates: Date[] = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(base);
    d.setDate(d.getDate() + 1 + i);
    dates.push(d);
  }
  return dates;
}

/** Short display label for a program day date, e.g. "Jul 25". */
export function formatProgramDateLabel(date: Date): string {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** YYYY-MM-DD for a local date (for plan_date columns). */
export function formatPlanDateISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

const DATE_LABEL_RE = /^[A-Z][a-z]{2}\s+\d{1,2}$/;

/** Whether a day label already looks like a "Jul 25" style date string. */
export function isDateLikeLabel(label?: string | null): boolean {
  return !!label && DATE_LABEL_RE.test(label.trim());
}
